// extracted by mini-css-extract-plugin
export var active = "_z-9";
export var backButton = "_z-8";
export var clone = "_z-e";
export var collapseBar = "_z-k";
export var collapseMode = "_z-m";
export var collapsed = "_z-o";
export var dimmed = "_z-i";
export var dragHandle = "_z-c";
export var dropdownIcon = "_z-g";
export var expanding = "_z-n";
export var hidden = "_z-x";
export var iconContainer = "_z-q";
export var iconSwapper = "_z-w";
export var navItem = "_z-6";
export var navItemIcon = "_z-f";
export var navProfile = "_z-7";
export var notificationCountBadge = "_z-j";
export var notificationDot = "_z-r";
export var optionsContainer = "_z-h";
export var primaryNav = "_z-0";
export var primaryNavDivider = "_z-v";
export var primaryNavResizeHandle = "_z-2";
export var primaryNavResizing = "_z-1";
export var primaryNavTabSection = "_z-u";
export var primaryTab = "_z-p";
export var primaryTabIconBox = "_z-s";
export var secondaryNav = "_z-3";
export var selected = "_z-t";
export var settingsNav = "_z-4";
export var settingsNavItems = "_z-5";
export var show = "_z-d";
export var sideNav = "_z-l";
export var teamItem = "_z-a";
export var userProfileItem = "_z-b";